import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { V3Body } from "../Typography";

export const V3DatePanelContent = styled.div<{ hasBorder?: boolean }>`
    display: flex;    

    > div {
        &:nth-child(1) {
            width: 100%;
            
            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                width: auto;
                border-right: ${({ theme, hasBorder }) => hasBorder ? `1px solid  ${theme.v3.colors.grey88};` : undefined};
            }
        }

        &:nth-child(2) {
            display: none;
            
            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                display: block;
                padding-left: ${({ hasBorder }) => hasBorder ? `24px` : undefined};
            }
        }
    }
    
    /* Doubled class so these beat react-datepicker.css, which can load after styled-components on client navigation */
    && {
        .react-datepicker__week {
            display: flex;
        }

        .react-datepicker__day {
            margin: 0;
            font-family: 'Inter', sans-serif;
            border-radius: 50%;
            width: 36px;
            height: 36px;
            line-height: 36px;
            font-size: 13px;
        } 

        .react-datepicker__day--in-range {
            background: ${({ theme }) => theme ? theme.v3.colors.lightBlue : null};
            color: ${({ theme }) => theme ? theme.v3.colors.blue : null};
        }
    
        .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range {
            background: ${({ theme }) => theme ? theme.v3.colors.lightBlue : null};
            color: ${({ theme }) => theme ? theme.v3.colors.blue : null};
        }

        .react-datepicker__day--in-range,
        .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range {
            &:empty {
                background: none;
            }
        }

        .react-datepicker__header {
            background-color: transparent;
            border: none;
            border-radius: 0;
        }

        .react-datepicker {
            border: none;
            font-family: 'Inter';
            font-size: 13px;
        }

        .react-datepicker__day-names {
            margin-top: 22px;

            .react-datepicker__day-name { 
                font-size: 14px;
                color: ${({ theme }) => theme ? theme.v3.colors.grey48 : null};
                font-weight: bold;
            }
        }
    }
`;

export const V3DPresetDropdownRow = styled.div<{ active?: boolean }>`
    padding: 8px 12px;
    min-width: 166px;
    border-radius: 6px;
    margin-right: 12px;
    text-align: center;
    background: ${({ theme, active }) => active ? theme.v3.colors.lightBlue : null};

    ${V3Body} {
        color:  ${({ theme, active }) => active ? theme.v3.colors.blue : null};
    }

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        text-align: left;
    }
    
    &:hover {
        cursor: pointer;
        background: ${({ theme }) => theme ? theme.v3.colors.lightBlue : null};

        ${V3Body} {
            color:  ${({ theme }) => theme ? theme.v3.colors.blue : null};
        }
    }
`;